import * as React from 'react';
import { Col, Row } from 'reactstrap';
import FAIcon from '../fAIcon/FAIcon';
import './FieldsetWarningBox.css';

interface FieldsetWarningBoxProps {
    legendTitel: string;
    fieldsetClass?: string;
    tableClass?: string;
    td1Width: string;
    td2Width: string;
    td2Content: React.ReactNode;
    td3Width?: string;
    td3Content?: React.ReactNode;
    useLogo?: boolean;
}

export const FieldsetWarningBox = (props: FieldsetWarningBoxProps) => {
    const fieldsetclasses: string[] = ['FieldsetWarningBox'];
    const tableclasses: string[] = ['FieldsetBoxTable'];
    if (props.fieldsetClass) {
        fieldsetclasses.push(props.fieldsetClass);
    }

    if (props.tableClass) {
        tableclasses.push(props.tableClass);
    }
    return (
        <Row>
            <Col md={12}>
                <form>
                    <fieldset className={fieldsetclasses.join(' ')}>
                        <legend>
                            <b>{props.legendTitel}</b>
                        </legend>
                        <table className={tableclasses.join(' ')}>
                            <tbody>
                                <tr>
                                    <td className="text-center" style={{ width: props.td1Width }}>
                                        {props.useLogo !== true && <FAIcon icon="exclamation-triangle" />}
                                        {props.useLogo === true && (
                                            <img id="welcomelogo" src="assets/logo_kreis.png" alt="kukundo-logo" />
                                        )}
                                    </td>
                                    <td className="text-center" style={{ width: props.td2Width }}>
                                        {props.td2Content}
                                    </td>
                                    <td className="text-center" style={{ width: props.td3Width }}>
                                        {props.td3Content}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </fieldset>
                </form>
            </Col>
        </Row>
    );
};



// WEBPACK FOOTER //
// ./src/components/fieldsetWarningBox/FieldsetWarningBox.tsx